class IndividualMessage {
    public Id: string;
    public Version: number;
    public SendDate: Date;
    public IsTask: boolean;
    public IsDraft: boolean;
    public IsGroupTask: boolean;
    public FromContactId: string;
    public DocumentPatientId: string;
    public Filename: string;
    public TypeTaskLookupId: string;
    public PriorityLookupId: string;
    public StartDate: Date;
    public DueDate: Date;
    public CreationDate: Date;
    public CreatedBy: string;
    public LastUpdateDate: Date;
    public LastUpdatedBy: string;
    public DeletionDate: Date;
    public DeletedBy: string;
    public ArchivalDate: Date;
    public ArchivedBy: string;
    public Subject: string;
    public Body: string;
    public OverallTaskStatusLookupId: string;
}

export { IndividualMessage };
